import React from 'react'

export default {
  Login: React.lazy(() => import('modules/LoginForm')),
  RecoverPassword: React.lazy(() => import('modules/RecoverPasswordForm')),
  NewPassword: React.lazy(() => import('modules/NewPasswordForm')),
  NewUserPilot: React.lazy(() => import('modules/PilotUserForm')),
  ItemAnalysis: React.lazy(() => import('modules/assignment/ItemAnalysis')),
  BenchmarkAssessments: React.lazy(() =>
    import('modules/benchmark-assessments/export/BenchmarkAssessments')
  ),
  //ToDo: Replace routing without ClassPageLoader Wrapper once teacherDashboard flag is ON for everyone
  Classes: React.lazy(() => import('modules/classesDashboard/ClassPageLoader')),
  ClassRoster: React.lazy(() => import('modules/classes/export/ClassRoster')),
  ClassPlanner: React.lazy(() => import('modules/classes/export/ClassPlanner')),
  CombinedClassRoster: React.lazy(() =>
    import('modules/CombinedClasses/Roster')
  ),
  CombinedClassPlanner: React.lazy(() =>
    import('modules/CombinedClasses/Planner')
  ),
  CoreCurriculumGrade: React.lazy(() =>
    import('modules/CoreELA/CoreCurriculumGrade')
  ),
  CoreCurriculumUnit: React.lazy(() =>
    import('modules/CoreELA/CoreCurriculumUnit')
  ),
  CoreCurriculumModule: React.lazy(() =>
    import('modules/CoreELA/CoreCurriculumModule')
  ),
  CoreCurriculumAdditionalLessons: React.lazy(() =>
    import('modules/CoreELA/CoreCurriculumAdditionalLessons')
  ),
  CskLesson: React.lazy(() => import('modules/csk/export/Lesson')),
  Curriculum: React.lazy(() => import('modules/curriculum/export/Curriculum')),
  LibraryAssessments: React.lazy(() =>
    import('modules/curriculum/export/LibraryAssessments')
  ),
  InstitutionAssessments: React.lazy(() =>
    import('modules/curriculum/export/InstitutionAssessments')
  ),
  PeriodDetails: React.lazy(() =>
    import('modules/curriculum/export/PeriodDetails')
  ),
  LessonsExplore: React.lazy(() =>
    import('modules/curriculum/components/LessonsExplore')
  ),
  CurriculumRedirect: React.lazy(() =>
    import('modules/curriculum/export/CurriculumRedirect')
  ),
  CurriculumDetail: React.lazy(() =>
    import('modules/curriculum/export/CurriculumDetail')
  ),
  CurriculumSearch: React.lazy(() =>
    import('modules/curriculum/export/CurriculumSearch')
  ),
  CurriculumCoordination: React.lazy(() =>
    import('modules/library/CurriculumCoordination')
  ),
  LibraryThinkCERCAPro: React.lazy(() =>
    import('modules/library/ThinkCERCAPro')
  ),
  LibrarySkills: React.lazy(() => import('modules/library/Skills')),
  LibrarySkillsDetailPage: React.lazy(() =>
    import('modules/library/SkillsDetailPage')
  ),
  LibraryBrowse: React.lazy(() => import('modules/library/Browse')),
  LibraryCoursesPage: React.lazy(() =>
    import('modules/library/Courses/Course')
  ),
  LibraryCourses: React.lazy(() => import('modules/library/Courses')),
  LibraryUnitsPage: React.lazy(() => import('modules/library/Units/Unit')),
  LibraryUnits: React.lazy(() => import('modules/library/Units')),
  LibraryUnitModules: React.lazy(() => import('modules/library/Units/Modules')),
  LibraryReadingPractice: React.lazy(() =>
    import('modules/library/ReadingPractice')
  ),
  LibraryCustomLessons: React.lazy(() =>
    import('modules/library/CustomLessons')
  ),
  LessonPrint: React.lazy(() => import('modules/lesson/LessonPrint')),
  CustomLessons: React.lazy(() => import('components/CustomLessons')),
  FlexibleStudentAssignment: React.lazy(() =>
    import('modules/FlexibleStudentAssignment')
  ),
  GradingHeader: React.lazy(() => import('components/GradingHeader')),
  NewGrading: React.lazy(() => import('modules/assignment/NewGrading')),
  InsightUnverified: React.lazy(() =>
    import('modules/insights/export/InsightUnverified')
  ),
  InstitutionClasses: React.lazy(() =>
    import('modules/classes/export/InstitutionClasses')
  ),
  InstitutionRoster: React.lazy(() => import('components/institution-roster')),
  AssignmentDetail: React.lazy(() =>
    import('modules/classes/export/AssignmentDetail')
  ),
  CombinedClassAssignmentDetail: React.lazy(() =>
    import('modules/classes/components/AssignmentDetail/CombinedClassAssignmentDetail')
  ),
  ModuleDetail: React.lazy(() =>
    import('modules/curriculum/export/ModuleDetail')
  ),
  LessonDetailPage: React.lazy(() =>
    import('modules/curriculum/export/LessonDetailPage')
  ),
  PreviewFlexibleLesson: React.lazy(() =>
    import('modules/PreviewFlexibleLesson')
  ),
  FlexibleLessonGroupDetailsPage: React.lazy(() =>
    import('modules/FlexibleLessonGroupDetailsPage')
  ),
  FlexibleLessonDetailsPage: React.lazy(() =>
    import('modules/FlexibleLessonDetailsPage')
  ),
  RosterManagement: React.lazy(() => import('components/RosterManagement')),
  StudentApp: React.lazy(() => import('modules/student/export/StudentApp')),
  UpgradeIndex: React.lazy(() => import('components/upgrade-index')),
  SubscriptionPage: React.lazy(() => import('components/SubscriptionPage')),
  UserProfile: React.lazy(() => import('modules/user/Profile')),
  SignUpDialog: React.lazy(() =>
    import('modules/registration/export/SignUpDialog')
  ),
  Resources: React.lazy(() => import('modules/curriculum/export/Resources')),
  Sitemap: React.lazy(() => import('components/Sitemap')),
  WritingLesson: React.lazy(() =>
    import('modules/WritingLesson/export/WritingLesson')
  ),
  Reporting: React.lazy(() => import('modules/Reporting/Reporting')),
  ProScoredClasses: React.lazy(() =>
    import('modules/ProScoredClasses/SchoolClasses')
  ),
  ProScoredClass: React.lazy(() =>
    import('modules/ProScoredClasses/SchoolClass')
  ),
  ProScoredClassModule: React.lazy(() =>
    import('modules/ProScoredClasses/SchoolClassModule')
  ),
  Loading: React.lazy(() => import('components/loading-full-screen/component')),
}
